'use client';

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import _, { first } from 'lodash';
import classNames from 'classnames';
import fx from 'fireworks';
import { t } from '../../i18n';
import { AnimateUpDown } from '../Animate';
import Icon from '../Icon';
import Modal from '../Modal/Modal';
import ModalFileSubmissionForm from '../ModalFileSubmissionForm/ModalFileSubmissionForm';
import LatestUpdatesModal from '../LatestUpdatesModal/LatestUpdatesModal';
import Richtext from '../Richtext/Richtext';

import s from './Sidemenu.module.scss';
import { CollapsibleMotion } from '../Animate/Animate';

const Sidemenu = ({
    id = 'nav',
    disclaimer = { modal: {} },
    items = {},
    secondaryLinks = [],
    modifier = '',
    className = null,
    listClassName = null,
    childClassName = null,
    itemClassName = null,
    itemActiveClassName = null,
    logoutUrl = null,
    toggleClassName = null,
    linkClassName = null,
    linkTextClassName = 'LinkText',
    linkIconClassName = null,
    supportForm = {},
    notificationCounts = {},
    latestUpdates = null,
    dashboardId = null,
}) => {
    const [isLatestUpdatesOpen, setIsLatestUpdatesOpen] = useState(false);
    const classes = classNames(
        s.Root,
        { [s[`Root--${modifier}`]]: modifier },
        className
    );

    const lvl1 = [
        { ...items, children: {} },
        ...Object.values(items.children ? items.children : {}),
    ];

    const reportsCount = notificationCounts?.reportPages;

    const firstPage = lvl1[0];

    const [easterEggPressCount, setEasterEggPressCount] = useState(0);

    const handleEasterClick = () => {
        setTimeout(() => setEasterEggPressCount(0), 1000);

        setEasterEggPressCount(easterEggPressCount + 1);
        if (easterEggPressCount >= 5) {
            fireworks();
        }
    };

    const fireworks = () => {
        const range = (n) => [...new Array(n)];

        setEasterEggPressCount(0);

        range(10).forEach((_, i) => {
            setTimeout(
                () => {
                    range(3).map(() =>
                        fx({
                            x:
                                Math.random() * (window.innerWidth / 2) +
                                window.innerWidth / 4,
                            y:
                                Math.random() * (window.innerHeight / 2) +
                                window.innerHeight / 4,
                            colors: [
                                '#e4f3fa',
                                '#d9edf6',
                                '#9fcbe0',
                                '#69a0bb',
                                '#427f9d',
                                '#26698b',
                                '#10435c',
                                '#113a4e',
                                '#0c2632',
                                '#fff3ee',
                                '#ffe4e4',
                                '#ffd0d0',
                                '#ffc1c9',
                                '#ff919f',
                                '#ff6779',
                                '#e2f0ff',
                                '#d2e8ff',
                                '#a4d1ff',
                                '#3d96ff',
                                '#0c42ff',
                                '#ecf4f2',
                                '#c7e4dd',
                                '#58b7a1',
                                '#fffce8',
                                '#fffabe',
                                '#fff14a',
                            ],
                        })
                    );
                },
                200 * i + Math.random() * 200
            );
        });
    };

    const parseDisclaimerText = (text) => {
        if (!text) {
            return text;
        }

        let regex = /(.*?){{(.*?)}}(.*)/;
        let matches = text.match(regex);

        if (matches) {
            return matches.slice(1, 4);
        } else {
            return text;
        }
    };

    const parsedDisclaimerText = parseDisclaimerText(disclaimer.text);

    return (
        <div className={classes}>
            <div className={s.Logo}>
                <button
                    className={s.EasterEggBtn}
                    onClick={handleEasterClick}></button>
                {!!firstPage?.url && (
                    <Link href={firstPage.url} aria-label="To start page">
                        <Icon name="LogoWhite" />
                    </Link>
                )}
            </div>
            <div className={s.Container}>
                <nav className={s.SubMenu} id={id}>
                    <List
                        items={lvl1}
                        navId={id}
                        className={listClassName}
                        childClassName={childClassName}
                        itemClassName={itemClassName}
                        itemActiveClassName={itemActiveClassName}
                        toggleClassName={toggleClassName}
                        linkClassName={linkClassName}
                        linkTextClassName={linkTextClassName}
                        linkIconClassName={linkIconClassName}
                        reportsCount={reportsCount}
                        isHidden={false}
                    />
                </nav>

                {(latestUpdates || !!secondaryLinks.length) && (
                    <div className={s.SecondaryLinks}>
                        {latestUpdates && (
                            <div className={s.Item}>
                                <button
                                    className={s.Link}
                                    onClick={() =>
                                        setIsLatestUpdatesOpen(true)
                                    }>
                                    <Icon
                                        name="Rocket"
                                        className={s.LatestUpdatesIcon}
                                    />
                                    <span className={s.LinkText}>
                                        {t('latestUpdates.menuLabel')}
                                    </span>
                                </button>
                            </div>
                        )}
                        {secondaryLinks.map((link, index) => (
                            <div key={index} className={s.Item}>
                                <a className={s.Link} href={link.url}>
                                    <span className={s.LinkText}>
                                        {link.title}
                                    </span>
                                </a>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <div className={s.Footer}>
                {/* <div className={s.CpartaLogoWrapper}>
                    <Icon name="Cparta" />
                    <span className={s.CpartaText}>
                        Cparta’s Cyber Threat Intelligence Service combines deep
                        technical insights with an understanding of geopolitical
                        dynamics to equip organizations with the foresight and
                        tools needed to anticipate and mitigate cyber threats.
                    </span>
                </div> */}
                <div className={s.FooterButtons}>
                    {/* <Modal
                        title="TBox Support"
                        buttonContent={
                            <div
                                className={s.FooterButton}
                                aria-label="Support">
                                <Icon name="SupportCircle" />
                                Support
                            </div>
                        }>
                        <SupportFormModal {...supportForm} />
                    </Modal> */}
                    {dashboardId && (
                        <ModalFileSubmissionForm
                            dashboardId={dashboardId}
                            isCustomButton
                            buttonContent={
                                <div className={s.FooterButton}>
                                    <Icon name="FolderUpload" />
                                    {t(
                                        'modalFileSubmissionForm.submitNewRequest'
                                    )}
                                </div>
                            }
                        />
                    )}
                    <a
                        href={logoutUrl}
                        className={s.FooterButton}
                        type="button"
                        aria-label="Logout">
                        <Icon name="Logout" />
                        Log out
                    </a>
                </div>
                <Modal
                    title={disclaimer.modal.title}
                    modifiers={['Sidebar']}
                    buttonContent={
                        <div className={s.DisclaimerButton}>
                            {!Array.isArray(parsedDisclaimerText) ? (
                                <span className={s.DisclaimerButtonContent}>
                                    {parsedDisclaimerText}
                                </span>
                            ) : (
                                <div className={s.DisclaimerButtonContent}>
                                    <span className={s.DisclaimerButtonText}>
                                        {parsedDisclaimerText[0]}
                                        <span
                                            className={s.DisclaimerButtonLink}>
                                            {parsedDisclaimerText[1]}
                                        </span>
                                        {parsedDisclaimerText[2]}
                                    </span>
                                </div>
                            )}
                        </div>
                    }
                    bottomButtonContent={
                        <div className={s.DisclaimerModalButton}>
                            {disclaimer.modal.buttonText}
                            <span className="sr-only">, close modal</span>
                        </div>
                    }>
                    <div className={s.Disclaimer}>
                        <Richtext text={disclaimer.modal.content} />
                    </div>
                </Modal>
            </div>
            {latestUpdates && (
                <LatestUpdatesModal
                    {...latestUpdates}
                    isOpen={isLatestUpdatesOpen}
                    onClose={() => setIsLatestUpdatesOpen(false)}
                />
            )}
        </div>
    );
};

Sidemenu.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    items: PropTypes.array.isRequired,
    modifier: PropTypes.string,
    classsName: PropTypes.string,
    listClassName: PropTypes.string,
    childClassName: PropTypes.string,
    itemClassName: PropTypes.string,
    itemActiveClassName: PropTypes.string,
    toggleClassName: PropTypes.string,
    linkClassName: PropTypes.string,
    linkTextClassName: PropTypes.string,
    linkIconClassName: PropTypes.string,
};

const List = ({
    items = [],
    navId = 'nav',
    id = null,
    className = null,
    childClassName = null,
    itemClassName = null,
    itemActiveClassName = null,
    toggleClassName = null,
    linkClassName = null,
    linkTextClassName = null,
    linkIconClassName = null,
    ancestors = [],
    reportsCount,
    isHidden = false,
}) => {
    const listId = id === null ? `${navId}-list` : `${navId}-${id}-list`;

    const classes = classNames(
        s.List,
        className,
        { [s['List--WithParent']]: ancestors.length > 1 },
        { [s['List--WithGrandParent']]: ancestors.length > 2 }
    );

    const findLastActive = (items) => {
        let lastActive = null;

        const traverse = (item) => {
            if (item.isActive) {
                lastActive = item.id;
            }
            Object.values(item.children).forEach(traverse);
        };

        Object.values(items).forEach(traverse);
        return lastActive;
    };

    const lastActiveId = findLastActive(items);

    return (
        <ul className={classes} aria-hidden={isHidden} id={listId}>
            {items.map((item, index) => (
                <Child
                    {...item}
                    navId={listId}
                    key={index}
                    ancestors={[...ancestors, item.id]}
                    className={childClassName}
                    listClassName={className}
                    itemClassName={itemClassName}
                    itemActiveClassName={itemActiveClassName}
                    itemLastActiveId={lastActiveId}
                    toggleClassName={toggleClassName}
                    linkClassName={linkClassName}
                    linkTextClassName={linkTextClassName}
                    linkIconClassName={linkIconClassName}
                    isParentActive={item.isActive}
                    reportsCount={reportsCount}
                    isHidden={isHidden}
                />
            ))}
        </ul>
    );
};

List.propTypes = {
    items: PropTypes.array.isRequired,
    navId: PropTypes.string.isRequired,
    id: PropTypes.string,
    isHidden: PropTypes.bool,
    className: PropTypes.string,
    childClassName: PropTypes.string,
    itemClassName: PropTypes.string,
    itemActiveClassName: PropTypes.string,
    toggleClassName: PropTypes.string,
    linkClassName: PropTypes.string,
    linkTextClassName: PropTypes.string,
    linkIconClassName: PropTypes.string,
    ancestors: PropTypes.array,
};
const Child = (item) => {
    const {
        navId = '',
        id = '',
        children = {},
        ancestors = [],
        isParentActive = false,
        className = null,
        listClassName = null,
        itemClassName = null,
        itemActiveClassName = null,
        toggleClassName = null,
        linkClassName = null,
        linkTextClassName = null,
        linkIconClassName = null,
        itemLastActiveId = null,
        notificationCounts = {},
        reportsCount,
        isHidden = false,
    } = item;

    const childs = children ? Object.values(children) : [];

    const [isExpanded, setIsExpanded] = useState(isParentActive);

    const hasChildren = !_.isEmpty(childs);
    const childId = `${navId}-${id}`;

    const level = ancestors.length; // Track the current level

    const classes = classNames(
        s.Child,
        { [s['Child--Expanded']]: isExpanded },
        { [s['Child--HasChildren']]: hasChildren },
        { [s['Child--ParentActive']]: isParentActive },
        className
    );

    return (
        <li className={classes} id={childId}>
            <Item
                {...item}
                navId={childId}
                ancestors={ancestors}
                isExpanded={isExpanded}
                showToggle={hasChildren}
                className={itemClassName}
                itemActiveClassName={itemActiveClassName}
                toggleClassName={toggleClassName}
                linkClassName={linkClassName}
                linkTextClassName={linkTextClassName}
                linkIconClassName={linkIconClassName}
                toggleExpanded={() => setIsExpanded(!isExpanded)}
                itemLastActiveId={itemLastActiveId}
                level={level} // Pass level prop here
                reportsCount={reportsCount}
                isFocusable={!isHidden}
            />

            {hasChildren && (
                <CollapsibleMotion isOpen={isExpanded}>
                    <List
                        items={childs}
                        isHidden={!isExpanded}
                        navId={childId}
                        className={listClassName}
                        childClassName={className}
                        itemClassName={itemClassName}
                        itemActiveClassName={itemActiveClassName}
                        toggleClassName={toggleClassName}
                        linkClassName={linkClassName}
                        linkTextClassName={linkTextClassName}
                        linkIconClassName={linkIconClassName}
                        ancestors={[...ancestors, id]}
                    />
                </CollapsibleMotion>
            )}
        </li>
    );
};

Child.propTypes = {
    navId: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    children: PropTypes.array,
    isParentActive: PropTypes.bool,
    ancestors: PropTypes.array,
    classsName: PropTypes.string,
    listClassName: PropTypes.string,
    itemClassName: PropTypes.string,
    itemActiveClassName: PropTypes.string,
    toggleClassName: PropTypes.string,
    linkClassName: PropTypes.string,
    linkTextClassName: PropTypes.string,
    linkIconClassName: PropTypes.string,
};

const Item = (item) => {
    const {
        navId = '',
        ancestors = [],
        id = '',
        modifier = '',
        showToggle = false,
        isExpanded = false,
        toggleExpanded = () => {},
        isActive = false,
        isParentActive = false,
        className = null,
        itemActiveClassName = null,
        toggleClassName = null,
        linkClassName = null,
        linkTextClassName = null,
        linkIconClassName = null,
        itemLastActiveId = null,
        level = 1, // Default level is 1
        reportsCount,
        isFocusable = true,
    } = item;

    const listId = `${navId}-list`;

    const isFirstParent = level === 1;

    const classes = classNames(
        s.Item,
        { [s['Item--Active']]: isActive },
        { [s[`Item--${modifier}`]]: modifier },
        className,
        { [`${itemActiveClassName}`]: isActive },
        { [s[`Item--LastActive`]]: itemLastActiveId === id }
    );

    const toggleClasses = classNames(s.Toggle, toggleClassName, {
        [s['Toggle--FirstParent']]: isFirstParent,
    });

    return (
        <div className={classes}>
            <CustomLink
                {...item}
                ancestors={ancestors}
                className={linkClassName}
                linkTextClassName={linkTextClassName}
                linkIconClassName={linkIconClassName}
                reportsCount={reportsCount}
                isFocusable={isFocusable}
            />

            {showToggle && (
                <button
                    className={toggleClasses}
                    type="button"
                    onClick={() => toggleExpanded()}
                    aria-expanded={isExpanded}
                    aria-controls={listId}
                    aria-label={t('nav.showChildren')}></button>
            )}
        </div>
    );
};

Item.propTypes = {
    navId: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    ancestors: PropTypes.array,
    modifier: PropTypes.string,
    showToggle: PropTypes.bool,
    isExpanded: PropTypes.bool,
    toggleExpanded: PropTypes.func,
    isActive: PropTypes.bool,
    isParentActive: PropTypes.bool,
    classsName: PropTypes.string,
    toggleClassName: PropTypes.string,
    linkClassName: PropTypes.string,
    linkTextClassName: PropTypes.string,
    linkIconClassName: PropTypes.string,
};

const CustomLink = ({
    title = '',
    url = '',
    target = null,
    rel = null,
    attrTitle = null,
    className = null,
    linkTextClassName = null,
    linkIconClassName = null,
    icon = '',
    isActive = false,
    reportsCount = 0,
    isReportPage = false,
    isFocusable = true,
}) => {
    const resolvedIcon = isActive && icon ? `${icon}Mobile` : icon;
    const classes = classNames(s.Link, className);

    const linkTextClasses = classNames(s.LinkText, linkTextClassName);
    const iconDownloadClasses = classNames(
        s.LinkIcon,
        linkIconClassName,
        s['LinkIcon--Download']
    );
    const iconExternalClasses = classNames(
        s.LinkIcon,
        linkIconClassName,
        s['LinkIcon--External']
    );

    return (
        <a
            className={classes}
            href={url}
            target={target}
            rel={rel}
            title={attrTitle}
            tabIndex={isFocusable ? 0 : -1}
            aria-hidden={!isFocusable}>
            {resolvedIcon && <Icon name={resolvedIcon} className={s.Icon} />}
            {typeof title === 'string' ? (
                <span
                    className={linkTextClasses}
                    dangerouslySetInnerHTML={{ __html: title }}
                />
            ) : (
                <span className={linkTextClasses}>{title}</span>
            )}
            {isReportPage && reportsCount > 0 && (
                <div suppressHydrationWarning className={s.LinkNotification}>
                    {reportsCount}
                </div>
            )}
        </a>
    );
};

CustomLink.propTypes = {
    title: PropTypes.node.isRequired,
    url: PropTypes.string.isRequired,
    target: PropTypes.string,
    rel: PropTypes.string,
    attrTitle: PropTypes.string,
    classsName: PropTypes.string,
    linkTextClassName: PropTypes.string,
    linkIconClassName: PropTypes.string,
};

export default Sidemenu;
